import script from "./backOfficeUserCreateFormModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./backOfficeUserCreateFormModal.vue?vue&type=script&lang=ts&setup=true"

import "./backOfficeUserCreateFormModal.vue?vue&type=style&index=0&id=012bd59a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012bd59a"]])

export default __exports__